/* Scent Nation street map engine: a minimal navy-on-white street map of any place, cut to a circle, a heart or a 2.4 : 1
 * rectangle ('rect', the map candles' own labels), for the Street Map label (label-templates.js 'streetmap', label-sn.js 'map'). Map data: OpenStreetMap via OpenFreeMap vector tiles (OpenMapTiles
 * schema; free, commercial use allowed, attribution required - printed on the label). Drawing: MapLibre GL JS (BSD),
 * loaded by the page. The same view (centre + zoom) gives the same map on the website preview and in the Label Studio.
 * Zoom is always stated for a 512 px square ("z512"), so a phone-sized editor and a print-sized render show the same
 * area. Needs window.maplibregl. */
(function (global) {
  'use strict';
  if (global.SNMap) return;
  var NAVY = '#1B2A4A';
  var HEART = 'M50 90C22 70 4 52 4 31 4 16 15 6 29 6c9 0 16 5 21 13 5-8 12-13 21-13 14 0 25 10 25 25 0 21-18 39-46 59z';

  var TONES = {
    navy: { road: NAVY, minor: NAVY, water: '#D8DFEA', waterway: '#C5D0E0', park: '#F1F2EC', building: '#EEEBE6', path: 0.55 },
    grey: { road: '#8A9097', minor: '#A3A8AE', water: '#DCE0E4', waterway: '#CBD1D7', park: '#F3F4F2', building: '#F0F0EF', path: 0.45 }  // Scent Nation's map candle labels
  };
  function style(tone) {
    var T = TONES[tone] || TONES.navy;
    var w = function (stops) { return ['interpolate', ['exponential', 1.6], ['zoom']].concat(stops); };
    var road = function (id, classes, stops, colour, extra) {
      return Object.assign({ id: id, type: 'line', source: 'omt', 'source-layer': 'transportation',
        filter: ['all', ['match', ['geometry-type'], ['LineString', 'MultiLineString'], true, false], ['match', ['get', 'class'], classes, true, false]],
        layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-color': colour, 'line-width': w(stops) } }, extra || {});
    };
    return {
      version: 8,
      sources: { omt: { type: 'vector', url: 'https://tiles.openfreemap.org/planet' } },
      layers: [
        { id: 'bg', type: 'background', paint: { 'background-color': '#FFFFFF' } },
        { id: 'park', type: 'fill', source: 'omt', 'source-layer': 'park', paint: { 'fill-color': T.park } },
        { id: 'water', type: 'fill', source: 'omt', 'source-layer': 'water', paint: { 'fill-color': T.water } },
        { id: 'waterway', type: 'line', source: 'omt', 'source-layer': 'waterway', paint: { 'line-color': T.waterway, 'line-width': w([10, 0.4, 16, 2]) } },
        { id: 'building', type: 'fill', source: 'omt', 'source-layer': 'building', minzoom: 15, paint: { 'fill-color': T.building } },
        road('path', ['path', 'track'], [13, 0.2, 18, 1.2], T.minor, { paint: { 'line-color': T.minor, 'line-opacity': T.path, 'line-width': w([13, 0.2, 18, 1.2]), 'line-dasharray': [2, 1.5] } }),
        road('minor', ['minor', 'service'], [11, 0.25, 14, 0.8, 18, 5], T.minor),
        road('tertiary', ['tertiary'], [9, 0.3, 14, 1.3, 18, 8], T.road),
        road('secondary', ['secondary'], [8, 0.4, 14, 1.8, 18, 10], T.road),
        road('primary', ['primary', 'trunk'], [6, 0.5, 14, 2.4, 18, 13], T.road),
        road('motorway', ['motorway'], [5, 0.6, 14, 3, 18, 15], T.road),
        road('rail', ['rail', 'transit'], [10, 0.3, 16, 1.2], T.road, { paint: { 'line-color': T.road, 'line-opacity': 0.6, 'line-width': w([10, 0.3, 16, 1.2]), 'line-dasharray': [3, 2] } })
      ]
    };
  }

  var RECT = 2.4; // 'rect' maps (the map candles' own labels) are 2.4 : 1
  function shapeImage(src, shape, size) { // cut the map to the shape (transparent outside) -> Promise(blob URL)
    var c = document.createElement('canvas'); c.width = size; c.height = shape === 'rect' ? Math.round(size / RECT) : size;
    var g = c.getContext('2d');
    g.save();
    if (shape === 'heart') { var p = new Path2D(HEART); g.scale(size / 100, size / 100); g.clip(p); g.setTransform(1, 0, 0, 1, 0, 0); }
    else if (shape !== 'rect') { g.beginPath(); g.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2); g.clip(); }
    g.drawImage(src, 0, 0, c.width, c.height);
    g.restore();
    // a short blob: URL, not a data: URL - the jar preview copies the label ~80 times
    return new Promise(function (res) { c.toBlob(function (b) { res(URL.createObjectURL(b)); }, 'image/png'); });
  }

  /** Off-screen render: {lat, lon, zoom, shape, tone, px} -> Promise(blob URL). px = output width in pixels. */
  function snapshot(o) {
    return new Promise(function (resolve, reject) {
      var ML = global.maplibregl; if (!ML) { reject(new Error('MapLibre not loaded')); return; }
      var px = o.px || 900, css = 512, ratio = px / css;
      var box = document.createElement('div');
      box.style.cssText = 'position:fixed;left:-99999px;top:0;width:' + css + 'px;height:' + (o.shape === 'rect' ? Math.round(css / RECT) : css) + 'px;pointer-events:none;';
      document.body.appendChild(box);
      var map = new ML.Map({ container: box, style: style(o.tone), center: [o.lon, o.lat], zoom: o.zoom || 14.5, interactive: false, attributionControl: false,
        preserveDrawingBuffer: true, pixelRatio: ratio, fadeDuration: 0 });
      var done = false, failed = 0, finish = function () {
        if (done) return; done = true;
        if (failed && !map.areTilesLoaded()) { map.remove(); box.remove(); reject(new Error('map tiles unavailable')); return; }  // never hand back a blank map
        shapeImage(map.getCanvas(), o.shape, px).then(resolve, reject).then(function () { map.remove(); box.remove(); });
      };
      map.on('error', function () { failed++; });
      map.once('idle', finish);
      setTimeout(finish, 15000); // slow network: use whatever has drawn
    });
  }

  /** Interactive editor in el: {lat, lon, zoom, shape, tone, onView(view)} -> {setCenter(lat, lon, zoom), view(), capture(px)} */
  function editor(el, o) {
    var ML = global.maplibregl; if (!ML) return null;
    var k = function () { return Math.log2(512 / (el.clientWidth || 512)); }; // z512 -> this map's zoom: z - k
    var map = new ML.Map({ container: el, style: style(o.tone), center: [o.lon, o.lat], zoom: (o.zoom || 14.5) - k(), attributionControl: { compact: true },
      preserveDrawingBuffer: true, dragRotate: false, pitchWithRotate: false, touchPitch: false, fadeDuration: 0 });
    map.touchZoomRotate.disableRotation();
    veil(el, o.shape);
    map.addControl(new ML.NavigationControl({ showCompass: false }), 'top-right');
    var view = function () { var c = map.getCenter(); return { lat: +c.lat.toFixed(5), lon: +c.lng.toFixed(5), zoom: +(map.getZoom() + k()).toFixed(2) }; };
    var t = 0;
    map.on('moveend', function () { clearTimeout(t); t = setTimeout(function () { map.once('idle', function () { if (o.onView) o.onView(view()); }); map.triggerRepaint(); }, 120); });
    map.once('idle', function () { if (o.onView) o.onView(view()); });
    return {
      map: map, view: view,
      setCenter: function (lat, lon, zoom) { map.jumpTo({ center: [lon, lat], zoom: zoom ? zoom - k() : map.getZoom() }); },
      capture: function (px) { return shapeImage(map.getCanvas(), o.shape, px || 700); }
    };
  }

  /* ---------- address search: Photon (komoot's public OpenStreetMap search) ----------
     Free, no key, fair use ("as long as the number of requests stay in a reasonable limit"), no availability guarantee.
     We ask at most once a second, only after typing pauses, and cache answers. Australia first, then the world. */
  var PHOTON = 'https://photon.komoot.io/api/';
  var AU_BOX = '112.5,-44.2,154.0,-9.0';
  var STATE_FULL = { nsw: 'New South Wales', vic: 'Victoria', qld: 'Queensland', wa: 'Western Australia', sa: 'South Australia', tas: 'Tasmania',
    act: 'Australian Capital Territory', nt: 'Northern Territory' };
  var STATE_ABBR = { 'New South Wales': 'NSW', Victoria: 'VIC', Queensland: 'QLD', 'Western Australia': 'WA', 'South Australia': 'SA', Tasmania: 'TAS',
    'Australian Capital Territory': 'ACT', 'Northern Territory': 'NT' };
  var geoCache = {}, geoLast = 0, geoChain = Promise.resolve();
  function zoomFor(p) {  // a house or street close up, a suburb a little wider, a city wider again
    var t = p.type || '';
    return t === 'house' ? 16.6 : t === 'street' ? 16 : t === 'district' || t === 'locality' ? 15 : t === 'city' ? 14.2 :
      t === 'county' ? 11 : t === 'state' ? 7 : t === 'country' ? 4.5 : 15.6;  // otherwise a venue, park or beach
  }
  function placeLabel(p) {  // "Magnus Street, Nelson Bay NSW"
    var first = p.name || [p.housenumber, p.street].filter(Boolean).join(' ');
    var town = p.city || p.locality || p.district || p.county || '', st = STATE_ABBR[p.state] || p.state || '';
    var out = [first];
    if (town && town !== first) out.push(town + (st ? ' ' + st : '')); else if (st && st !== first) out.push(st);
    if (p.countrycode && p.countrycode !== 'AU' && p.country) out.push(p.country);
    if (p.housenumber && p.street && p.name && p.name !== p.street) out.splice(1, 0, p.housenumber + ' ' + p.street);
    return out.filter(Boolean).join(', ');
  }
  var NOT_STOPS = '&osm_tag=!highway:bus_stop&osm_tag=!public_transport:platform&osm_tag=!public_transport:stop_position&osm_tag=!railway:platform';
  function photon(q, box) {
    return fetch(PHOTON + '?limit=8&lang=en&q=' + encodeURIComponent(q) + (box ? '&bbox=' + box : '') + NOT_STOPS).then(function (r) {
      if (!r.ok) throw new Error('place search ' + r.status);
      return r.json();
    }).then(function (j) {
      var seen = {};
      return (j.features || []).map(function (f) {
        var p = f.properties || {}, c = f.geometry && f.geometry.coordinates;
        return c ? { label: placeLabel(p), lat: +c[1], lon: +c[0], zoom: zoomFor(p), type: p.type || '' } : null;
      }).filter(function (r) { return r && r.label && !seen[r.label] && (seen[r.label] = 1); }).slice(0, 5);
    });
  }
  // what people type -> what the map data says: states and street types in full ("Panorama Rd Denmark WA" -> "Panorama Road Denmark
  // Western Australia"); "St"/"Dr" only after a street name, so "St Mary's" and "Dr ..." stay as they are
  var STREET = { rd: 'Road', ave: 'Avenue', av: 'Avenue', cres: 'Crescent', pde: 'Parade', hwy: 'Highway', ln: 'Lane', ct: 'Court', pl: 'Place',
    tce: 'Terrace', blvd: 'Boulevard', bvd: 'Boulevard', cct: 'Circuit', esp: 'Esplanade', st: 'Street', dr: 'Drive' };
  function expand(q) {
    return q.replace(/\b(nsw|vic|qld|wa|sa|tas|act|nt)\b\.?/gi, function (m) { return STATE_FULL[m.replace('.', '').toLowerCase()] || m; })
      .replace(/([A-Za-z'’]+\s+)(rd|ave|av|cres|pde|hwy|ln|ct|pl|tce|blvd|bvd|cct|esp|st|dr)\b\.?/gi, function (_, w, t) { return w + STREET[t.toLowerCase()]; });
  }
  /** Address, street, venue, beach or town -> Promise([{label, lat, lon, zoom, type}]), best first. */
  function geocode(q) {
    q = String(q || '').trim().replace(/\s+/g, ' ');
    if (q.length < 3) return Promise.resolve([]);
    var key = q.toLowerCase();
    if (geoCache[key]) return Promise.resolve(geoCache[key]);
    var qq = expand(q), bare = qq.replace(/,?\s*(New South Wales|Victoria|Queensland|Western Australia|South Australia|Tasmania|Australian Capital Territory|Northern Territory)\b\.?,?(\s*\d{4})?\s*$/i, '').replace(/,?\s*\d{4}\s*$/, '').trim();
    var pause = function () { var w = Math.max(0, geoLast + 1000 - Date.now()); return new Promise(function (r) { setTimeout(r, w); }).then(function () { geoLast = Date.now(); }); };
    var tries = [[qq, AU_BOX]].concat(bare && bare !== qq ? [[bare, AU_BOX]] : []).concat([[qq, '']]);
    var run = function () {
      var i = 0, next = function (res) {
        if ((res && res.length) || i >= tries.length) return res || [];
        var t = tries[i++];
        return pause().then(function () { return photon(t[0], t[1]); }).then(next);
      };
      return next(null);
    };
    var p = geoChain.then(run, run);
    geoChain = p.catch(function () {});
    return p.then(function (res) { geoCache[key] = res; return res; });
  }
  var SEARCH_CREDIT = 'Place search: Photon by komoot · © OpenStreetMap contributors';

  /** "Map view" order value <-> {lat, lon, zoom} */
  function fmtView(v) { return v ? v.lat.toFixed(5) + ', ' + v.lon.toFixed(5) + ' · z' + v.zoom.toFixed(2) : ''; }
  function parseView(s) {
    var r = /(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)(?:\s*·?\s*z\s*(\d+(?:\.\d+)?))?/i.exec(String(s || ''));
    return r ? { lat: +r[1], lon: +r[2], zoom: r[3] ? +r[3] : 14.5 } : null;
  }
  /** a translucent veil outside the circle / heart, drawn over the editor so customers see the crop */
  function veil(el, shape) {
    var cut = shape === 'heart' ? HEART : shape === 'rect' ? 'M0.4 0.4H99.6V99.6H0.4Z' : 'M50 0.4A49.6 49.6 0 1 1 49.99 0.4Z';
    var d = document.createElement('div');
    d.className = 'snmap-veil'; d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:2';
    d.innerHTML = '<svg viewBox="0 0 100 100" preserveAspectRatio="none" style="width:100%;height:100%;display:block">' +
      '<path fill-rule="evenodd" fill="rgba(255,255,255,0.62)" d="M0 0H100V100H0Z' + cut + '"/>' +
      '<path d="' + cut + '" fill="none" stroke="#D4622A" stroke-width="0.5"/></svg>';
    el.appendChild(d);
  }

  global.SNMap = { style: style, snapshot: snapshot, editor: editor, fmtView: fmtView, parseView: parseView, HEART: HEART,
    ATTRIBUTION: '© OpenStreetMap contributors · OpenMapTiles', RECT: RECT, geocode: geocode, SEARCH_CREDIT: SEARCH_CREDIT, ready: true };
})(window);
